<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex d-flex xs12 sm6 md9>
                <v-card color="white">
                  <v-card-title primary class="title grey ">
                    <span>
                      <v-icon large color="white">
                        fiber_manual_record
                      </v-icon>
                    </span>
                    {{programNavTitle}}
                  </v-card-title>
                  <div v-for="(item, index) in tabelItems" :key="index">
                    <v-card-title v-if="item.title.length > 0" primary class="title">{{item.title}}</v-card-title>
                    <v-card-text>{{ item.text }}</v-card-text>
                    <ImageView v-if="index == 0" :imgFirst="imgFirstSrc" :imgSecond="imgSecondSrc" />
                  </div>
                </v-card>
            </v-flex>
            <v-flex d-flex xs12 sm6 md3>
                <v-card color="white">
                  <v-card-title primary class="title grey pa-4">
                    {{kontaktInfo1}}
                  </v-card-title>
                <v-card-text>
                    <p>{{ kontaktInfo2a }} {{ kontaktInfo2b }}</p>
                    <p>{{ kontaktInfo2c }}</p>

                    <p>{{ kontaktInfo3a }}</p>
                    <p>{{ kontaktInfo3b }}</p>
                    <p>{{ kontaktInfo3c }}</p>

                    <p>{{ kontaktInfo4a }}</p>
                    <p>{{ kontaktInfo4b }}</p>
                    <p>{{ kontaktInfo4c }}</p>
                </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import * as dataOfExchange from './exchanges/exchange'
  import ImageView from './exchanges/ImageView'
  import { mapState, mapGetters } from 'vuex'
  import { EventBus } from '../events'

  export default {
    data: () => {
      return {
        tabelItems: [],
        imgFirstSrc: require('@/assets/exchange1.png'),
        imgSecondSrc: require('@/assets/exchange2.png'),
      }
    },
    mounted(){
      EventBus.$emit('show', false)

      this.updateParagraphs(this.languageSelected)

      EventBus.$on('language', lang => {
        this.updateParagraphs(lang)
      })
    },
    computed: {
        ...mapState('ContactModule', [
            'programText',

            'programNavTitle',

            'kontaktInfo1',
            'kontaktInfo2a',
            'kontaktInfo2b',
            'kontaktInfo2c',
            'kontaktInfo3a',
            'kontaktInfo3b',
            'kontaktInfo3c',
            'kontaktInfo4a',
            'kontaktInfo4b',
            'kontaktInfo4c',
          ]),
      ...mapGetters('ContactModule', {
        languageSelected: 'language',
      }),
    },
    components:{
      ImageView,
    },
    methods: {
      updateParagraphs(val){
        console.log(dataOfExchange.data.de.paragraphs)
        console.log(dataOfExchange.data.en.paragraphs)
        if(val == 'DE'){
          this.tabelItems = dataOfExchange.data.de.paragraphs
        } else {
          this.tabelItems = dataOfExchange.data.en.paragraphs
        }
      }
    }
  }
</script>
